export const highlightText = (text: string | null, keywords: string[]): (string | JSX.Element)[] => {
  if (!text) return [];
  if (!keywords.length) return [text];
  text = text.toString(); // Ensure text is a string

  // Convert keywords to lowercase for comparison
  const lowercaseKeywords = keywords.map(k => k.toLowerCase());
  // Create case-insensitive pattern
  const pattern = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  const regex = new RegExp(`(${pattern})`, 'gi');
  // Split by regex and highlight matches while preserving original case
  return text.split(regex).map((part, i) =>
    lowercaseKeywords.includes(part.toLowerCase()) ? (
      <span key={i} className="bg-yellow-200 dark:bg-yellow-600 leading-none px-0">{part}</span>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};
